module.exports = __webpack_public_path__ + "img/total-application-o.ebf0b7c4.svg";